/**
 * BananaScare — a gag jump scare. When a Ripe Banana hits the ground (any drop),
 * the whole screen flashes black and a giant banana lunges out while
 * banana-scream.mp3 blasts. Purely cosmetic; changes no game state.
 *
 * Production: always ON — the scare is part of the shipped experience and the
 * toggle is hidden. Dev (Vite dev server / localhost): togglable from the pause
 * menu, choice persisted in localStorage, defaults ON.
 */
const KEY = "relikara.bananaScare";

// Dev when running under the Vite dev server; fall back to a hostname check.
const DEV = (() => {
  try { if (typeof import.meta !== "undefined" && import.meta.env) return !!import.meta.env.DEV; } catch (_) {}
  try { return ["localhost", "127.0.0.1", ""].includes(location.hostname); } catch (_) { return false; }
})();

export class BananaScare {
  constructor(audio) {
    this.audio = audio;
    this.dev = DEV;
    const saved = this._loadRaw();
    this.enabled = saved === null ? true : saved === "1";     // persisted, defaults ON
    this._el = null;
    this._timer = null;
  }

  _loadRaw() { try { return localStorage.getItem(KEY); } catch (_) { return null; } }
  _save() { try { localStorage.setItem(KEY, this.enabled ? "1" : "0"); } catch (_) {} }

  /** Everyone can toggle it from Settings now (defaults on). */
  canToggle() { return true; }
  isEnabled() { return this.enabled; }
  setEnabled(v) { this.enabled = !!v; this._save(); return this.enabled; }
  toggle() { return this.setEnabled(!this.enabled); }

  /** True when the given item should set off the scare. */
  isBanana(item) { return !!item && (item.id === "banana" || /banana/i.test(item.name || "")); }

  _build() {
    if (this._el) return this._el;
    const el = document.createElement("div");
    el.id = "bananaScare";
    el.setAttribute("aria-hidden", "true");
    el.innerHTML = `<div class="bs-flash"></div><div class="bs-banana">🍌</div>`;
    document.body.appendChild(el);
    this._el = el;
    return el;
  }

  /** Fire the scare (only when enabled). Visual + scream. */
  trigger() {
    if (!this.enabled) return;
    const el = this._build();
    el.classList.remove("show");
    // force reflow so re-adding .show restarts the animation on repeat drops
    void el.offsetWidth;
    el.classList.add("show");
    if (this.audio && typeof this.audio.sfx === "function") this.audio.sfx("banana_scream", 1.5);
    clearTimeout(this._timer);
    this._timer = setTimeout(() => el.classList.remove("show"), 1400);
  }

  /** Convenience: scare only if the dropped item is a banana. */
  maybeScare(item) { if (this.isBanana(item)) this.trigger(); }
}
